import request from '../request'

export function fetchList(params) {
    return request({
        url: '/user-service/role/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/user-service/role/add',
        method: 'POST',
        data,
    })
}

export function fetchDetail(params) {
    return request({
        url: '/user-service/role/id',
        params
    })
}

export function edit(data) {
    return request({
        url: '/user-service/role/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/user-service/role/delete',
        method: 'POST',
        data
    })
}

// 批量修改角色下的用户列表（添加/移除都用这个接口，传完整用户 uuid 数组替换）
// data: { roleUUId, userUUIds: [] }
export function updateUsers(data) {
    return request({
        url: '/user-service/role/updateUsers',
        method: 'POST',
        data
    })
}

// 根据角色UUID查询关联的菜单列表
export function getMenusByRoleUuid(roleUuid) {
    return request({
        url: `/user-service/menuPermission/menusByRole/${roleUuid}`,
    })
}